import type { DriveStep } from 'driver.js'

export type TourId =
  | 'director_dashboard'
  | 'director_projects'
  | 'director_project_card'
  | 'director_users'
  | 'gip_dashboard'
  | 'gip_project_card'
  | 'designer_dashboard'

export const TOURS: Record<TourId, DriveStep[]> = {
  director_dashboard: [
    {
      element: '[data-tour="kpi-block"]',
      popover: {
        title: '📊 KPI-блок',
        description: 'Три счётчика: просрочено разделов, срок через 5 дней, принято за месяц. Нажмите на число - перейдёте к деталям.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="gantt-chart"]',
      popover: {
        title: '📅 Диаграмма Ганта',
        description: 'Горизонтальная лента всех активных проектов. Красный бар - есть просрочка, жёлтый - срок менее 5 дней. Нажмите на бар → карточка проекта.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="zone-preproject"]',
      popover: {
        title: '📁 Предпроектная зона',
        description: 'Проекты на этапе подготовки: согласование ТЗ, договора, исходные данные.',
        side: 'right',
      },
    },
    {
      element: '[data-tour="zone-active"]',
      popover: {
        title: '⚙️ Зона «В работе»',
        description: 'Активные проекты с блочным видом. Цвет рамки слева - статус по срокам.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="attention-block"]',
      popover: {
        title: '⚠️ Требуют внимания',
        description: 'Разделы с просрочкой или горящим сроком. Фильтруйте: Все / Просрочено / Скоро срок.',
        side: 'top',
      },
    },
  ],

  director_projects: [
    {
      element: '[data-tour="new-project-btn"]',
      popover: {
        title: '➕ Новый проект',
        description: 'Создайте проект: укажите шифр, название, заказчика, адрес, сроки и назначьте ГИП.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="projects-tabs"]',
      popover: {
        title: '📂 Вкладки проектов',
        description: 'Активные → текущие проекты. Завершённые → постпроектная стадия. Удалённые → корзина (только директора).',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="project-search"]',
      popover: {
        title: '🔍 Поиск',
        description: 'Ищите по шифру или названию проекта.',
        side: 'bottom',
      },
    },
  ],

  director_project_card: [
    {
      element: '[data-tour="project-tabs"]',
      popover: {
        title: '📋 Вкладки документации',
        description: 'ИРД → исходно-разрешительная документация (с инженерными изысканиями). ПД → проектная. ГГЭ → экспертиза. РД → рабочая.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="add-section-btn"]',
      popover: {
        title: '➕ Добавить раздел',
        description: 'Укажите шифр раздела, назначьте исполнителя и установите сроки. Исполнитель получит письмо.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="project-history-btn"]',
      popover: {
        title: '📜 История изменений',
        description: 'Полный журнал всех изменений проекта и разделов с датами и авторами.',
        side: 'left',
      },
    },
  ],

  director_users: [
    {
      element: '[data-tour="add-user-btn"]',
      popover: {
        title: '👤 Добавить сотрудника',
        description: 'Укажите email и роль. Сотрудник получит приглашение и сам заполнит ФИО и телефон.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="users-table"]',
      popover: {
        title: '📋 Список сотрудников',
        description: 'Нажмите на строку → нагрузка сотрудника. Иконка письма → повторное приглашение. Кнопка питания → блокировка.',
        side: 'bottom',
      },
    },
  ],

  gip_dashboard: [
    {
      element: '[data-tour="gantt-chart"]',
      popover: {
        title: '📅 Ваши проекты на Ганте',
        description: 'Все проекты: ваши первыми и яркие, чужие ниже и бледнее (только просмотр). Красный бар - просрочка, жёлтый - срок ≤5 дней.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="attention-block"]',
      popover: {
        title: '⚠️ Горящие разделы',
        description: 'Разделы с просрочкой или близким сроком: ваши первыми, чужие ниже и бледнее. Нажмите на раздел - откроется проект.',
        side: 'top',
      },
    },
  ],

  gip_project_card: [
    {
      element: '[data-tour="project-tabs"]',
      popover: {
        title: '📋 Типы документации',
        description: 'Добавляйте разделы в нужный тип: ИРД, ПД, ГГЭ или РД.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="add-section-btn"]',
      popover: {
        title: '➕ Новый раздел',
        description: 'Добавьте раздел: шифр обязателен. Назначьте проектировщика - он получит уведомление.',
        side: 'bottom',
      },
    },
  ],

  designer_dashboard: [
    {
      element: '[data-tour="gantt-chart"]',
      popover: {
        title: '📅 Ваши проекты',
        description: 'Проекты где вам назначен хотя бы один раздел.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="attention-block"]',
      popover: {
        title: '📌 Ваши разделы',
        description: 'Разделы с близким или истёкшим сроком. Нажмите → перейдёте в проект.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="zone-active"]',
      popover: {
        title: '🏗️ Активные проекты',
        description: 'Нажмите на карточку проекта чтобы открыть его и увидеть свои разделы.',
        side: 'bottom',
      },
    },
  ],
}

/** Какой тур запускать по умолчанию для роли на данном пути */
export function getDefaultTour(role: string, pathname: string): TourId | null {
  if (pathname === '/dashboard') {
    if (role === 'director' || role === 'deputy_director') return 'director_dashboard'
    if (role === 'chief_engineer') return 'gip_dashboard'
    if (role === 'designer') return 'designer_dashboard'
  }
  if (pathname === '/projects') {
    if (role === 'director' || role === 'deputy_director') return 'director_projects'
  }
  if (/^\/projects\/[^/]+$/.test(pathname) && pathname !== '/projects/new') {
    if (role === 'director' || role === 'deputy_director') return 'director_project_card'
    if (role === 'chief_engineer') return 'gip_project_card'
  }
  if (pathname === '/users') {
    if (role === 'director' || role === 'deputy_director') return 'director_users'
  }
  return null
}
